module.exports = __webpack_public_path__ + "img/5.8ed91e4b.png";